import { DataRecoveryLegalCaseMutations } from './partials/legal-case'

export const DataRecoveryMutations = {
  ...DataRecoveryLegalCaseMutations,

  setSearchLoading: (state, value) => {
    state.dataRecovery.isSearching = value
  },
}
